import { Form, FormProps } from 'antd'

import { useParams } from 'react-router-dom'

import AddUserInfo from 'modules/AccessManage/components/AddUserInfo'
import AddUserKeyAccess from 'modules/AccessManage/components/AddUserKeyAccess'
import { useUser } from 'modules/AccessManage/hooks/useUser'
import { UserInfoFormState } from 'modules/AccessManage/types'

import PrimaryButton from 'shared/ui/PrimaryButton'
import Title from 'shared/ui/Title'

const AddUser = () => {
  const { userId } = useParams()
  const { handleCreateUser, cleanUserObject, isCreateUserLoading } = useUser({
    userId,
  })
  const [form] = Form.useForm<UserInfoFormState>()
  const onFinish: FormProps<UserInfoFormState>['onFinish'] = (data) => {
    const body = cleanUserObject(data)
    if (data.password !== data.password_verification) {
      form.setFields([
        {
          name: 'password',
          errors: ['Пароли не совпадают'],
        },
        {
          name: 'password_verification',
          errors: ['Пароли не совпадают'],
        },
      ])

      return
    }
    handleCreateUser(body)
  }
  return (
    <Form
      form={form}
      onFinish={onFinish}
      className="flex-1 flex flex-col"
    >
      <div className="flex-1 flex flex-col justify-between">
        <div className="p-[24px]">
          <div className="py-[12px]">
            <Title
              className="!mb-0 !font-bold !leading-[32px] !text-dark_2"
              level={3}
            >
              Добавление пользователя
            </Title>
          </div>
          <div className="mt-[28px] flex gap-[20px]">
            <AddUserInfo form={form} />
            <AddUserKeyAccess />
          </div>
        </div>
        <div className="p-[24px] pt-[12px] flex justify-end bg-light_gray_2">
          <PrimaryButton
            disabled={isCreateUserLoading}
            className="rounded-[16px]"
            htmlType="submit"
            text="Добавить пользователя"
          />
        </div>
      </div>
    </Form>
  )
}

export default AddUser
